import React from 'react';
export function ProblemSection() {
  return <section className="w-full px-4" data-id="element-145">
      {/* Part 1 — White */}
      <div className="max-w-2xl mx-auto py-8 border-t border-gray-200" data-id="element-146">
        <p className="text-center text-lg font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-147">
          Si sos padre o madre, esto te va a sonar familiar
        </p>

        <h2 className="text-3xl md:text-4xl font-black text-center text-black mb-8 leading-tight" data-id="element-148">
          Te sentás a ayudar a tu Hijo…
        </h2>

        <div className="max-w-xl mx-auto text-lg md:text-xl text-gray-700 leading-relaxed space-y-4 mb-10" data-id="element-149">
          <p data-id="element-150">Y en pocos minutos pasa esto:</p>
          <p data-id="element-151">
            Le explicás y no entiende, dice no me sale, se distrae o se bloquea
            se frustra… y vos también
          </p>
          <p data-id="element-152">Y lo que empezó como ayuda… termina en tensión.</p>
          <p data-id="element-153">
            A veces incluso evitás ese momento, porque sabés cómo va a terminar.
            Y queda esa sensación incómoda: “No lo estoy ayudando como debería”
          </p>
        </div>
      </div>

      {/* Part 2 — Black */}
      <div className="bg-black text-white py-8 -mx-4 px-4" data-id="element-154">
        <div className="max-w-2xl mx-auto text-center" data-id="element-155">
          <p className="text-lg font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-156">
            El problema que nadie te explica
          </p>

          <h3 className="text-3xl md:text-5xl font-black text-yellow-400 mb-4" data-id="element-157">
            No es tu hijo. Y tampoco sos vos.
          </h3>

          <p className="text-2xl font-black text-red-400 mb-8" data-id="element-158">
            Es que nadie te enseñó:
          </p>

          <ul className="text-left max-w-md mx-auto space-y-3 text-lg md:text-xl font-medium mb-10" data-id="element-159">
            <li className="flex items-start" data-id="element-160">
              <span className="text-yellow-400 mr-3 flex-shrink-0" data-id="element-161">•</span>
              cómo funciona realmente el aprendizaje infantil
            </li>
            <li className="flex items-start" data-id="element-162">
              <span className="text-yellow-400 mr-3 flex-shrink-0" data-id="element-163">•</span>
              cómo acompañar sin generar presión
            </li>
            <li className="flex items-start" data-id="element-164">
              <span className="text-yellow-400 mr-3 flex-shrink-0" data-id="element-165">•</span>
              cómo explicar para que entienda de verdad
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-400 uppercase tracking-widest mb-6" data-id="element-166">
            Entonces todo se repite:
          </p>

          <p className="text-xl md:text-2xl font-black text-yellow-400 leading-loose mb-10" data-id="element-167">
            Intentás ayudar → no funciona → hay enojo → evitás el momento →{' '}
            <span className="text-red-400" data-id="element-168">vuelve a pasar</span>
          </p>

          <p className="text-xl md:text-2xl font-bold text-gray-300 italic" data-id="element-169">
            Y queda esa sensación constante de:
            <br data-id="element-170" />
            <span className="text-white text-2xl md:text-3xl font-black not-italic block mt-2" data-id="element-171">
              "No lo estoy ayudando como debería"
            </span>
          </p>
        </div>
      </div>
    </section>;
}